import { useEffect, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { usePageStore } from '@legacy/stores/PageStore/pageStore.zustand';
import { getFetch } from '@legacy/utils/fetcher';
import { parseMenu } from '@legacy/utils/menu';
import { useTranslation } from 'react-i18next';
import {
  IMenus,
  IMenusPropertiesWithPagePath,
} from '@legacy/apis/types/menusAPI';

const PAGE_SETTINGS_MENU_URL_PATH = '/api/v2/menus/page-settings';
export const PAGE_SETTINGS_MENU_MSW_STATUS_KEY = 'pageSettingsAPI';

export const PAGE_SETTINGS_MENU_KEY = 'PAGE_SETTINGS';

const getPageSettingsMenu = (): Promise<IMenus> =>
  getFetch({
    path: PAGE_SETTINGS_MENU_URL_PATH,
    key: PAGE_SETTINGS_MENU_MSW_STATUS_KEY,
  });

export const usePageSettingsMenu = () => {
  const { data, ...restProps } = useQuery({
    queryKey: [PAGE_SETTINGS_MENU_KEY],
    queryFn: getPageSettingsMenu,
  });
  const { t } = useTranslation('pageSettingsNavigation');
  const pageSettingMenu: IMenusPropertiesWithPagePath[] = useMemo(
    () => parseMenu(data, t),
    [data, t],
  );
  const setPageSettings = usePageStore((s) => s.setPageSettings);
  useEffect(() => {
    if (setPageSettings && pageSettingMenu) setPageSettings(pageSettingMenu); // menuItems is the payload (array of IMenusProperties)
  }, [pageSettingMenu, setPageSettings]);
  return {
    pageSettingMenu,
    isPageSettingMenuEmpty: pageSettingMenu.length <= 0,
    data,
    ...restProps,
  };
};
